import { render, staticRenderFns } from "./activity-multi.vue?vue&type=template&id=bb06a9d0&scoped=true"
import script from "./activity-multi.vue?vue&type=script&lang=js"
export * from "./activity-multi.vue?vue&type=script&lang=js"
import style0 from "./activity-multi.vue?vue&type=style&index=0&id=bb06a9d0&prod&scoped=scoped&lang=less"
import style1 from "./activity-multi.vue?vue&type=style&index=1&id=bb06a9d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb06a9d0",
  null
  
)

export default component.exports